// GTM is already loaded via index.html
// This module provides utility functions for pushing events to dataLayer

export function initGoogleTagManager(id = "G-QYGN2X4EKQ") {
  // GTM is already loaded via index.html, just ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];

  // Ensure gtag function is available for consent mode
  if (!window.gtag) {
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };
  }

  console.log("Analytics module initialized - using existing GTM");
  return window.gtag;
}

// Export a tracking function for page views
// This pushes page_view events to dataLayer for GTM to process
export function trackPageView(path) {
  // Push page_view event to dataLayer
  // GTM will handle this and fire appropriate tags based on consent
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'page_view',
    page_path: path,
    page_location: window.location.href,
    page_title: document.title
  });

  console.log('Page view tracked via dataLayer:', path);
}
